import React, { useEffect, useContext, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GlobalContext } from "@context/GlobalContext";
import useLocale from "@hooks/useLocale";
import AnnouncementBar from "../AnnouncementBar";
import { getOriginalLocale, isHomePage } from "@helpers/GlobalHelpers";
import { SUPPORTED_USER_LANG } from "@constants/common";

const Announcement = () => {
	const { currentLanguage } = useLocale();
	const [globalState, setGlobalState] = useContext(GlobalContext);
	const [announcement, setAnnouncement] = useState(null);

	const dataQuery = useStaticQuery(graphql`
        query {
            aepsyCms {
                announcements(locale: "de-CH", pagination: { limit: 100 }) {
                    content
                    locale
                    endAt
                    startAt
                    slugPattern
                    pages {
                        slug
                        locale
                    }
                }
            }
        }
    `);

	const getCurrentPageSlug = () => {
		const pathNames =
			typeof window !== "undefined" ? window.location.pathname.split("/") : [];
		return isHomePage()
			? "/"
			: pathNames.find(
					(item: string) => ![...SUPPORTED_USER_LANG, "/", ""].includes(item),
				);
	};

	const setData = (data: any) => {
		setAnnouncement(data);
		setGlobalState((prevData) => ({
			...prevData,
			hasAnnouncement: true,
		}));
	};

	useEffect(() => {
		if (dataQuery) {
			const {
				aepsyCms: { announcements: announcementsData },
			} = dataQuery;
			announcementsData.forEach((announcementByLang: any) => {
				if (getOriginalLocale(announcementByLang.locale) === currentLanguage) {
					const {
						pages: pagesData,
						slugPattern,
						endAt,
						startAt,
						content,
					} = announcementByLang;

					const currentPageSlug = getCurrentPageSlug();

					const today = new Date();
					const isUnexpired =
						today >= new Date(startAt) && today <= new Date(endAt);

					if (
						slugPattern &&
						slugPattern.split(",").includes(currentPageSlug) &&
						isUnexpired
					) {
						setData(content);
						return;
					}

					const announcementBySlug = pagesData.find(
						(item) =>
							typeof window !== "undefined" &&
							item.slug.includes(currentPageSlug),
					);

					if (announcementBySlug && isUnexpired) {
						setData(content);
						return;
					}
				}
			});
		}
	}, [dataQuery]);

	if (announcement) {
		return <AnnouncementBar markdown={announcement} />;
	}

	return <></>;
};

export default Announcement;
